import { IPageTabNavLink } from "../interfaces-and-types";

export const reportdocumentLink: IPageTabNavLink[] = [
    {
        name: 'Documents',
        route: '',
    },
]